/** @format */
import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    detailArticle: {},
  },
  mutations: {
    setDetailArticle(state, payload) {
      state.detailArticle = payload
    },
  },
  actions: {
    fetchArticleList(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get('/birthday/list', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteArticle(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete('/birthday/delete', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    createArticle(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post('/birthday/create', queryParams)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    editArticle(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put('/birthday/edit', queryParams)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
